import { IUserData } from "../User/IUserData";

export interface IHistoryFileApiResponse {
  Action: HistoryFileActionEnum;
  ItemId: string;
  ItemName: string;
  ParentName: string;
  From: IHistoryFileDetail;
  To: IHistoryFileDetail;
  DateTimeUtc: Date;
  Author: IUserData;
  NewValue: string;
  OldValue: string;
}

export interface IHistoryFileDetail {
  Value: string;
  DisplayValue: string;
}

export enum HistoryFileActionEnum {
  StatusChanged = 0,
  FileDownloaded = 1,
  FileDeleted = 2,
  FileMetadataChanged = 3,
  FileMoved = 4,
  FolderCreated = 5,
  FolderDeleted = 6,
  FileRenamed = 7,
  DescriptionUpdated = 8,
  FileCreated = 9,
  FileVersionAdded = 10,
  FileRendered = 11
}

export interface IHistoryFileRequestList {
  title: string;
  parentName: string;
  itemId: string;
  isFolder: boolean;
}

export interface IHistoryFileResponseList {
  title: string;
  parentName: string;
  histories: IHistoryFileApiResponse[];
}
